export default __webpack_public_path__ + "c277c438fd13c041f530a481305d59b6.docx";